import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface ILoginStatus {
  /**
   * 资金账号登录状态
   *
   * @type {boolean}
   * @memberof ILoginStatusResponse
   * @example {'tradeLogin': true}
   */
  tradeLogin: boolean
}

interface ILoginStatusResponse {
  success?: (result: ILoginStatus) => void
  fail?: (result: ILoginStatus) => void
  complete?: (result: ILoginStatus) => void
}

/**
 * 获取资金账号登录状态
 *
 * @param {IBridgeOptions<ILoginStatusResponse>} {
 *   success,
 *   fail,
 *   complete
 * }
 */
function getFundAccountLoginStatusSync({
  success,
  fail,
  complete
}: IBridgeOptions<ILoginStatusResponse>) {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getUserLoginStatus'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getFundAccountLoginStatusSync error: ', error)
  }
}

/**
 * 获取资金账号登录状态
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<ILoginStatus>}
 */
function getFundAccountLoginStatus(): Promise<ILoginStatus> {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getUserLoginStatus'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getFundAccountLoginStatus, getFundAccountLoginStatusSync }
